export const KeyValueDisplay = {
    mixed: 'mixed',
    stacked: 'stacked',
    horizontal: 'horizontal',
    full: 'full',
    stackedFull: 'stacked-full'
};
